import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useAddSubscription = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IAddSubscriptionRequestData): Promise<Types.IAddSubscriptionResponseData> => {
        const { data } = await send<Types.IAddSubscriptionRequestData, Types.IAddSubscriptionResponseData>({
            ID: 35850,
            description: 'Add Subscription',
            responses: [35851, 35852],
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
